import { useState, useEffect } from 'react';

import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';

const useProductAR = () => {
  const {
    loading: basicLoading,
    error: basicError,
    data: basicData,
  } = usePDPBasicDetails();

  const [isARsupported, setIsARsupported] = useState(false);

  useEffect(() => {
    const targetElement = document.querySelector('a');
    if (targetElement?.relList?.supports('ar') && !isARsupported) {
      setIsARsupported(true);
    }
  }, [isARsupported]);

  return {
    loading: basicLoading,
    error: basicError,
    data: {
      isARsupported,
      arAsset: isARsupported ? basicData?.custom_properties?.ar_asset : null,
      arAssetUpholstery: isARsupported
        ? basicData?.custom_properties?.ar_asset_upholstery
        : null,
      arPrice: basicData?.meta?.price?.final_price || 0,
    },
  };
};

export default useProductAR;
